import React from 'react'
import { InfoIcon, SortArrowUpIcon, SortArrowDownIcon } from '../Icons'
import './index.sass'

const MarketsTableHeader = ({ columns, sortBy, sortDirection, onSort }) => {
  // Функція для обробки тексту: якщо це "24h Change", ми обгортаємо "Change" у span
  const renderLabel = (label) => {
    if (label === '24h Change') {
      return (
        <>
          24h <span className="markets-table-header__label-word-hide">Change</span>
        </>
      )
    }
    return label
  }

  const infoIcon = (
    <span className="markets-table-header__info" aria-hidden>
      <InfoIcon />
    </span>
  )

  return (
    <thead className="markets-table-header">
      <tr>
        {columns.map((column) => {
          const isSortable = column.sortable
          const isActive = isSortable && sortBy === column.key
          const isAsc = isActive && sortDirection === 'asc'

          return (
            <th
              key={column.key}
              className={`markets-table-header__cell markets-table-header__cell--${column.key} ${
                column.align === 'right' ? 'markets-table-header__cell--align-right' : ''
              }`}
            >
              {isSortable ? (
                <button
                  type="button"
                  className="markets-table-header__button"
                  onClick={() => onSort(column.key)}
                >
                  <span className="markets-table-header__label">
                    {renderLabel(column.label)}
                  </span>

                  <span className="markets-table-header__sort" aria-hidden>
                    <span className={`markets-table-header__sort-arrow markets-table-header__sort-arrow--up ${isActive && isAsc ? 'markets-table-header__sort-arrow--active' : ''}`}>
                      <SortArrowUpIcon />
                    </span>
                    <span className={`markets-table-header__sort-arrow markets-table-header__sort-arrow--down ${isActive && !isAsc ? 'markets-table-header__sort-arrow--active' : ''}`}>
                      <SortArrowDownIcon />
                    </span>
                  </span>

                  {column.info && infoIcon}
                </button>
              ) : (
                <span className="markets-table-header__static">
                  <span className="markets-table-header__label">
                    {renderLabel(column.label)}
                  </span>

                  {column.info && infoIcon}
                </span>
              )}
            </th>
          )
        })}
      </tr>
    </thead>
  )
}

export default MarketsTableHeader